import i18n from '@/i18n';

import { OPTION_MAIL_I } from '@/views/pages/phase2/manager-form/advanced/components/setting-email/constants.js';
import { ID_PAGE_TYPE } from '@/views/pages/phase2/manager-form/constants.js';

const getValueColumnMail = (itemMail, mailLogs) => {
    if (!mailLogs || !Array.isArray(mailLogs)) return '';
    return mailLogs.find((mail) => mail.block_id == itemMail.block_id) || '';
};

const getBgColorDeletedCol = (isDeleted) => {
    return isDeleted ? '#e3e3e3' : '';
};

const getStyleDeletedCol = (isDeleted) => {
    const bgColor = getBgColorDeletedCol(isDeleted);
    return bgColor ? `background-color: ${bgColor}` : '';
};

const getFormattedHeader = (item, config = { key: 'table' }) => {
    const isDeleteCol = item?.is_deleted;
    let obj = {
        block_name: `${item.block_name}${isDeleteCol ? `${i18n.t('managerForm.settingPage.pageTypeB.isDeleted')}` : ''}`
    };
    if (config.key === 'table') {
        return {
            label: `${item.block_name}${isDeleteCol ? `${i18n.t('managerForm.settingPage.pageTypeB.isDeleted')}` : ''}`,
            width: isDeleteCol ? 150 : 120,
            backgroundColor: getBgColorDeletedCol(isDeleteCol),
            ...obj
        };
    }

    return obj;
};

const handleSyncMailHeaders = (dataList, listBlockForm, headers, idTypeForm = ID_PAGE_TYPE.A) => {
    if (!dataList || !Array.isArray(dataList)) return { listMailLogs: [], headers };

    // Find all unique block_ids present in the current dataList's email_logs
    let activeBlockIds = [];
    activeBlockIds = new Set(
        dataList
            .flatMap((item) => item.email_logs || [])
            .map((e) => e?.block_id)
            .filter(Boolean)
            .map(String)
    );

    if (idTypeForm === ID_PAGE_TYPE.B) {
        const getRelated = dataList
            ?.filter((item) => item?.related_submit_result !== null)
            .map((item) => item?.related_submit_result)
            .flatMap((item) => item?.email_logs || []);

        activeBlockIds = new Set(
            getRelated
                .map((e) => e?.block_id)
                .filter(Boolean)
                .map(String)
        );
    }
    // Build listMailLogs ordered by listBlockForm to ensure consistent column order
    const listMailLogs = listBlockForm
        .filter((block) => activeBlockIds.has(String(block.id)))
        .map((block) => ({
            block_id: block.id === OPTION_MAIL_I.id ? block.id : Number(block.id),
            is_deleted: block.is_deleted
        }));

    if (activeBlockIds.has(OPTION_MAIL_I.id)) {
        listMailLogs.push({ block_id: OPTION_MAIL_I.id });
    }

    // Separate non-email headers from the current headers
    const nonEmailHeaders = headers.filter((header) => {
        return !(header.label.startsWith('サンキューメール - ') || header.label.startsWith('状態 - '));
    });

    // Rebuild email headers strictly based on the ordered listMailLogs
    const emailHeaders = [];
    listMailLogs.forEach((item) => {
        if (item.block_id === OPTION_MAIL_I.id) {
            emailHeaders.push({
                label: `サンキューメール - ${OPTION_MAIL_I.label}`,
                width: 260
            });
            emailHeaders.push({
                label: `状態 - ${OPTION_MAIL_I.label}`,
                width: 180
            });
        } else {
            const itemBlock = listBlockForm.find((itemBlock) => itemBlock.id === item.block_id);
            if (itemBlock) {
                emailHeaders.push({
                    ...itemBlock,
                    label: `サンキューメール - ${itemBlock.block_name}`,
                    width: 260
                });
                emailHeaders.push({
                    ...itemBlock,
                    label: `状態 - ${itemBlock.block_name}`,
                    width: 180
                });
            }
        }
    });

    return {
        listMailLogs,
        headers: [...nonEmailHeaders, ...emailHeaders]
    };
};

const handleSyncProductContentsHeaders = (dataList, headers, previousAddedKeys) => {
    let productContentsKeys = [];
    if (dataList && Array.isArray(dataList)) {
        dataList.forEach((item) => {
            if (item.product_contents && Array.isArray(item.product_contents)) {
                item.product_contents.forEach((content) => {
                    if (content.label && !productContentsKeys.includes(content.label)) {
                        productContentsKeys.push(content.label);
                    }
                });
            }
        });
    }

    let newHeaders = headers.filter((h) => !previousAddedKeys.includes(h.label));

    const targetIndex = newHeaders.findIndex((h) => h.label === '賞品コード');
    if (targetIndex !== -1 && productContentsKeys.length > 0) {
        const columnsToAdd = productContentsKeys.map((k) => ({ label: k, width: 120 }));
        newHeaders.splice(targetIndex + 1, 0, ...columnsToAdd);
    }

    return {
        headers: newHeaders,
        productContentsKeysAdded: productContentsKeys
    };
};

export { getValueColumnMail, handleSyncMailHeaders, handleSyncProductContentsHeaders, getFormattedHeader, getBgColorDeletedCol, getStyleDeletedCol };
